import { CommonModule as AngularCommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RivModule } from '@rivet-health/design-system';
import { ComponentsModule } from '../components/module';
import { CoreModule } from '../core/module';
import { UnsavedChangesOutletComponent } from './unsaved-changes-outlet.component';
import { UnsavedChangesComponent } from './unsaved-changes.component';

@NgModule({
  imports: [AngularCommonModule, ComponentsModule, CoreModule, RivModule],
  declarations: [UnsavedChangesComponent, UnsavedChangesOutletComponent],
  exports: [UnsavedChangesComponent, UnsavedChangesOutletComponent],
})
export class UnsavedChangesModule {}
